var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner edi-bill-search-selector",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_SettingValuePriority"),
            width: "320px",
            height: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              return _vm.cancel()
            }
          }
        },
        [
          _vm.innerVisible
            ? _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { height: "230px" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.localValList,
                            "show-header": false,
                            "highlight-current-row": ""
                          },
                          on: { "current-change": _vm.handleCurrentChange }
                        },
                        [
                          _c("el-table-column", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [_vm._v(_vm._s(row.name))])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              110465955
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-left": "15px"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "margin-left": "5px",
                                "margin-bottom": "5px"
                              },
                              attrs: {
                                disabled: !_vm.currentVal,
                                type: "primary"
                              },
                              on: { click: _vm.moveUp }
                            },
                            [_vm._v("↑")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: !_vm.currentVal,
                                type: "primary"
                              },
                              on: { click: _vm.moveDown }
                            },
                            [_vm._v("↓")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "4" },
                  on: { click: _vm.confirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "5" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }